import React from "react"
import {
	Flex,
	Text,
	INNER_MAX_WIDTH,
	READABLE_LINE_MAX_WIDTH,
} from "@capioweb/ui-components"
import { ContentAreaProperty } from "../../@types/CapioWeb/core"
import { StringProperty } from "../../@types/EpiFoundationSpa/Property"
import { PageBaseProps } from "../../components/Core/pageBase"
import { BlockResolver, BreadcrumbsBlock } from "../../components"
interface MyPagesAccountRemovedPageProps extends PageBaseProps {
	heading: StringProperty
	preamble?: StringProperty
	cta?: ContentAreaProperty
}
const MyPagesAccountRemovedPage: React.FC<MyPagesAccountRemovedPageProps> = (
	props
) => {
	return (
		<Flex display="block" w={1}>
			<BreadcrumbsBlock items={...props.breadcrumb} />
			<Flex as="section" w={1} px={3}>
				<Flex
					w={1}
					flexDirection="column"
					maxw={INNER_MAX_WIDTH}
					my={0}
					mx="auto"
				>
					<Flex
						w={1}
						flexDirection={{ _: "column", l: "row" }}
						columnGap={{ l: 3 }}
						py={4}
					>
						<Flex
							w={1}
							flex={{ _: 1, l: 8 / 12 }}
							flexDirection="column"
							maxw={READABLE_LINE_MAX_WIDTH}
						>
							{props.heading?.value && (
								<Text variant="headline-1">{props.heading.value}</Text>
							)}
							{props.preamble?.value && (
								<Text variant="preamble">{props.preamble.value}</Text>
							)}
							{props.cta?.value && (
								<Flex w="auto" mb={3} display={{ _: "block", l: "none" }}>
									<BlockResolver blocks={props.cta?.value} />
								</Flex>
							)}
						</Flex>
						<Flex
							w={1}
							mb={3}
							flex={{ _: 1, l: 4 / 12 }}
							alignSelf="flex-start"
							display={{ _: "none", l: "block" }}
						>
							{props.cta?.value && <BlockResolver blocks={props.cta?.value} />}
						</Flex>
					</Flex>
				</Flex>
			</Flex>
		</Flex>
	)
}
export { MyPagesAccountRemovedPage }
